import { BarLabel, type BarLabelProps } from '@mui/x-charts/BarChart';

const CHAR_WIDTH_PX = 7;
const INSIDE_PADDING_PX = 16;
const TEXT_OFFSET_PX = 6;

export const SmartBarLabel = (props: BarLabelProps) => {
  const { width, height, x, y, xOrigin, layout, children } = props;

  if (
    layout !== 'horizontal' ||
    typeof children !== 'string' ||
    children.length === 0
  ) {
    return <BarLabel {...props} />;
  }

  const labelText = children;
  const estimatedTextWidth = labelText.length * CHAR_WIDTH_PX;
  const barWidth = Math.abs(width);

  const fitsInside = barWidth >= estimatedTextWidth + INSIDE_PADDING_PX;
  if (!fitsInside) {
    return <BarLabel {...props} />;
  }

  const isPositive = x + width >= xOrigin;
  const labelX = isPositive ? x + width - TEXT_OFFSET_PX : x + TEXT_OFFSET_PX;
  const textAnchor = isPositive ? 'end' : 'start';
  const labelY = y + height / 2;

  return (
    <text
      x={labelX}
      y={labelY}
      textAnchor={textAnchor}
      dominantBaseline='central'
      style={{
        fill: '#fff',
        fontFamily: '"Open Sans", sans-serif',
        fontSize: 14,
        fontWeight: 600,
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.6)',
        pointerEvents: 'none',
      }}
    >
      {labelText}
    </text>
  );
};
